export default __webpack_public_path__ + "static/media/turnierdetails.aed71281.jpg";